module.exports = __webpack_public_path__ + "static/media/virus (13).be4f6f5b.png";